module.exports = __webpack_public_path__ + "static/media/s5.2b340a22.svg";